export default "__VITE_ASSET__CS_7e4gh__"